module.exports = __webpack_public_path__ + "static/media/Sold.1cce90f4.png";